import Providers from './providers';

class Element {
	constructor(element) {
		this.element = element;
		this.element.analytics = this;
		this.data = JSON.parse(this.element.dataset.analytics);

		this.providers = [
			new Providers.Google(this.data.google),
			new Providers.Yandex(this.data.yandex)
		];

		if (this.data.bind) {
			const binded_element = (() => {
				switch (this.data.event) {
					case 'load':
						return window;
					default:
						return this.element;
				}
			})();

			const self = this;

			this.eventHandler = function (event) {
				if (event.type == 'submit') {
					event.preventDefault();

					self.send(() => self.element.submit());
				} else {
					self.send();
				}
			};

			binded_element
				.addEventListener(this.data.event, this.eventHandler);
		}
	}

	send(callback) {
		let sent = 0;

		this.providers.forEach(provider => {
			const for_analytics = this.element.dataset.forAnalytics;
			if (for_analytics) provider.set(JSON.parse(for_analytics));
			provider.send(() => {
				sent++;
				if (sent < this.providers.length) return;
				if (callback) callback();
			});
		});
	}
}

export { Element };
